import Button from 'components/utils/Button';
import useResponsive from 'hooks/useResponsive';
import useTranslation from 'hooks/useTranslation';

import style from './index.style';

const TEMPLATES = [
  {
    title: 'Dawn',
    src: '/images/channel/template_basic.jpeg',
    alt: 'Template basic',
    href: 'https://themes.shopify.com/themes/dawn/styles/default/preview?architecture%5B%5D=os2&surface_inter_position=1&surface_intra_position=1&surface_type=all',
  },
];

export default function ModalTurnkey({ role }) {
  const { TRANSLATIONS } = useTranslation();
  const { isMobile, isTablet, isLaptop, isDesktop, isBigDesktop } =
    useResponsive();

  return (
    <div className="d-f fd-c">
      <div className="wrapper-shopify">
        <div className="d-f ai-c fd-c">
          <h4>{TRANSLATIONS.pricing.modal.template}</h4>
          <p>{TRANSLATIONS.pricing.modal.templateDescription}</p>
        </div>
        <div
          className={`turnkey-templates-container ${isMobile ? ' mb-xxl' : ''}`}
        >
          {TEMPLATES?.map((template, index) => (
            <div key={template?.src} className={'d-f fd-c ai-c'}>
              <img
                className="slider-image"
                src={template?.src}
                alt={template?.alt}
              />
              <div className={'turnkey-template-description'}>
                <span className="turnkey-template-title">
                  {template?.title}
                </span>
              </div>
              <div className="d-f ai-c jc-c">
                <a href={template?.href} target="_blank" rel="noreferrer">
                  <Button
                    className={'outlined medium'}
                    label={TRANSLATIONS.pricing.modal.viewTemplate}
                  />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style jsx>{style}</style>
    </div>
  );
}
